(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm"] && !Shopify.designMode) return;
  try {
    
  class Pm {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-vp]');
      this.track = section.querySelector('[data-track]');
      this.firstSet = section.querySelector('[data-set]');

      if (!this.viewport || !this.track || !this.firstSet) return;

      this.loopWidth = 1;
      this.baseX = 0;
      this.dragOffset = 0;
      this.targetX = 0;
      this.currentX = 0;
      this.dragging = false;
      this.pointerId = null;
      this.startPointerX = 0;
      this.startDragOffset = 0;
      this.rafId = null;
      this.resizeObserver = null;
      this.loops = Number(section.dataset.loops || 3);

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.animate = this.animate.bind(this);

      this.init();
    }

    init() {
      this.measure();
      this.onScroll();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('pointermove', this.onPointerMove, { passive: false });
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.firstSet);
        this.resizeObserver.observe(this.viewport);
      }

      this.animate();
    }

    measure() {
      const setRect = this.firstSet.getBoundingClientRect();
      const trackStyle = window.getComputedStyle(this.track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
      this.loopWidth = Math.max(1, setRect.width + gap);
      this.dragOffset = this.normalize(this.dragOffset);
      this.currentX = this.normalize(this.currentX);
      this.targetX = this.normalize(this.targetX);
    }

    onResize() {
      this.measure();
      this.onScroll();
    }

    onScroll() {
      const rect = this.section.getBoundingClientRect();
      const maxScroll = Math.max(1, this.section.offsetHeight - window.innerHeight);
      const passed = Math.min(maxScroll, Math.max(0, -rect.top));
      const progress = passed / maxScroll;
      const travel = progress * this.loopWidth * this.loops;
      this.baseX = -(travel % this.loopWidth);
    }

    onPointerDown(event) {
      this.dragging = true;
      this.pointerId = event.pointerId;
      this.startPointerX = event.clientX;
      this.startDragOffset = this.dragOffset;
      this.viewport.classList.add('is-dragging');
      this.viewport.setPointerCapture?.(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.dragging || event.pointerId !== this.pointerId) return;
      event.preventDefault();
      const deltaX = event.clientX - this.startPointerX;
      this.dragOffset = this.normalize(this.startDragOffset + deltaX);
    }

    onPointerUp(event) {
      if (!this.dragging) return;
      if (event.pointerId !== this.pointerId) return;

      this.dragging = false;
      this.pointerId = null;
      this.viewport.classList.remove('is-dragging');
    }

    normalize(value) {
      if (!this.loopWidth) return value;
      let normalized = value % this.loopWidth;
      if (normalized > 0) normalized -= this.loopWidth;
      return normalized;
    }

    animate() {
      this.targetX = this.normalize(this.baseX + this.dragOffset);
      this.currentX += (this.targetX - this.currentX) * 0.12;
      this.currentX = this.normalize(this.currentX);
      this.track.style.transform = `translate3d(${this.currentX}px, 0, 0)`;
      this.rafId = window.requestAnimationFrame(this.animate);
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.viewport.removeEventListener('pointerdown', this.onPointerDown);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
      this.resizeObserver?.disconnect();
      if (this.rafId) window.cancelAnimationFrame(this.rafId);
    }
  }

  window.pmMap = window.pmMap || new Map();

  const initPm = () => {
    document.querySelectorAll('[data-pm]').forEach((section) => {
      const id = section.id;
      if (window.pmMap.has(id)) return;
      window.pmMap.set(id, new Pm(section));
    });
  };

  const destroyPm = (sectionId) => {
    const instance = window.pmMap.get(sectionId);
    if (!instance) return;
    instance.destroy();
    window.pmMap.delete(sectionId);
  };

  document.addEventListener('DOMContentLoaded', initPm);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.querySelector?.('[data-pm]') || event.target;
    if (section?.matches?.('[data-pm]')) {
      const id = section.id;
      destroyPm(id);
      window.pmMap.set(id, new Pm(section));
    } else {
      initPm();
    }
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target?.id) destroyPm(event.target.id);
  });

  } catch(e) { console.error(e); }
})();
})();
